/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import UniversalTracker from './UniversalTracker';
import { UserMin } from '@g17eco/types/user';
import { UniversalTrackerModalTab } from '@g17eco/types/universalTrackerModal';
import { UniversalTrackerModalServiceUtrv, UniversalTrackerValuePlain } from '@g17eco/types/universalTrackerValue';
import { ExistingEvidenceFile } from '@g17eco/types/file';

class UniversalTrackerModalService {
  universalTracker: UniversalTracker;
  initiativeId?: string;
  universalTrackerValues?: UniversalTrackerModalServiceUtrv[];
  documents: ExistingEvidenceFile[] = [];
  users: UserMin[] = [];
  currentValue?: Pick<UniversalTrackerValuePlain, '_id' | 'initiativeId' | 'history'>;
  currentValueId?: string;
  activeTabId?: UniversalTrackerModalTab['navId'];

  constructor(data: any) {
    this.universalTracker = new UniversalTracker(data);
    this.documents = data.documents || [];
    this.users = data.users || [];
  }

  setUniversalTrackerValues(utrvs: UniversalTrackerModalServiceUtrv[] | undefined) {
    this.universalTrackerValues = utrvs;
  }

  getUniversalTracker() {
    return this.universalTracker;
  }

  setInitiativeId(initiativeId: string | undefined) {
    this.initiativeId = initiativeId;
  }

  getInitiativeId() {
    if (this.initiativeId) {
      return this.initiativeId;
    }
    const currentValue = this.getCurrentValue();
    if (currentValue) {
      return (this.initiativeId = currentValue.initiativeId);
    }
  }

  getUniversalTrackerValues() {
    return this.universalTrackerValues || [];
  }

  getActiveTabId() {
    return this.activeTabId;
  }

  setActiveTabId(activeTabId?: UniversalTrackerModalTab['navId']) {
    this.activeTabId = activeTabId;
  }

  universalTrackerValuesLoaded() {
    return Array.isArray(this.universalTrackerValues);
  }

  setCurrentValueId(universalTrackerValueId: string) {
    this.currentValueId = universalTrackerValueId;
  }

  setCurrentValue(value: Pick<UniversalTrackerValuePlain, '_id' | 'initiativeId'>) {
    this.setCurrentValueId(value._id);
    this.currentValue = value;
  }

  private getCurrentValue() {
    if (this.currentValue) {
      return this.currentValue;
    }

    if (!this.currentValueId) {
      return;
    }

    const utrv = this.universalTrackerValues?.find((utrv) => utrv._id === this.currentValueId);
    if (!utrv) {
      return;
    }

    return (this.currentValue = utrv);
  }
}

export default UniversalTrackerModalService;
